import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(err => err);
};
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch(err => err);
};

const router = new Router({
  routes: [
    {
      path: "/report",
      component: () => import("@/views/wx/report")
    },
    {
      path: "/",
      redirect: "/signIn"
    },
    {
      path: "/signIn",
      name: "SignIn",
      component: () => import("@/views/SignIn")
    },
    {
      path: "/home",
      name: "home",
      component: () => import("@/views/home/home")
    }, // 首页
    {
      path: "/index",
      name: "HomeIndex",
      component: () => import("@/views/HomeIndex/HomeIndex")
    },
    {
      path: "/home/article",
      name: "article",
      component: () => import("@/views/article/article")
    }, // 文章
    {
      path: "/article/bodypage",
      name: "bodypage",
      component: () => import("@/views/article/bodypage")
    }, // 文章详情
    {
      path: "/home/music",
      name: "music",
      component: () => import("@/views/music/music")
    }, // 文章详情
    {
      path: "/home/PsychologicalVideo",
      name: "PsychologicalVideo",
      component: () => import("@/views/PsychologicalVideo/PsychologicalVideo")
    }, // 心理课堂
    {
      path: "/PsychologicalVideo/playVideo",
      name: "playVideo",
      component: () => import("@/views/PsychologicalVideo/playVideo")
    }, // 心理课堂视频播放
    {
      path: "/home/cptask",
      name: "cptask",
      component: () => import("@/views/cptask/cptask")
    }, // 测评任务
    {
      path: "/home/eyetask",
      name: "eyetask",
      component: () => import("@/views/cptask/eyetask")
    }, // 测评任务
    {
      path: "/personal",
      name: "personal",
      component: () => import("@/views/personal/personal")
    }, // 个人信息
    {
      path: "/home/Evaluation",
      name: "Evaluation",
      component: () => import("@/views/Evaluation/Evaluation")
    }, // 测评记录
    {
      path: "/ReportList",
      name: "ReportList",
      component: () => import("@/views/ReportList/ReportList")
    }, // 报告列表
    {
      path: "/teacher",
      name: "teacher",
      component: () => import("@/views/teacher/teacher")
    }, // 教师介绍
    {
      path: "/ceshidati",
      name: "ceshidati",
      component: () => import("@/views/cptask/ceshidati")
    }, // 教师介绍
    {
      path: "/userReport",
      name: "userReport",
      component: () => import("@/views/Evaluation/userReport")
    },
    {
      path: "/home/Scale",
      name: "Scale",
      component: () => import("@/views/scale/scale")
    }
  ]
});
router.beforeEach((to, from, next) => {
  let token = sessionStorage.getItem("token");
  if (to.path == "/signIn" || to.path == "/report") {
    next();
  } else {
    if (token == null || token == "") {
      next("/signIn");
    } else {
      next();
    }
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js